import { subDays, startOfMonth } from 'date-fns';
import { ParkingLocation } from '../types/parkingLocation';

const HOURLY_TOW_LOOKBACK_DAYS = 30;

export function getLookupStartDate(lookupPeriod: number): string {
	let date: Date;

	if (lookupPeriod === -1) {
		// Start of the current month
		date = startOfMonth(new Date());
	} else if (lookupPeriod > 0) {
		// Go back `lookupPeriod` days
		date = subDays(new Date(), lookupPeriod);
	} else {
		// Default case (in case lookupPeriod is 0 or invalid)
		date = new Date();
	}

	return date.toISOString(); // Return as ISO 8601 string
}

/**
 * Lookup window for the ticket-history fetch, chosen per the lot's
 * violation-check mode. Hourly mode needs a 30-day window to cover tow
 * escalation, even though the overstay check itself uses the maxStayMinutes
 * limit.
 */
export function getLookupStartDateForParkingLocation(
	parkingLocation: Pick<
		ParkingLocation,
		'violationCheckType' | 'violationCheckWindowDays'
	>,
): string {
	if (parkingLocation.violationCheckType === 'hourlyExpiry') {
		return subDays(new Date(), HOURLY_TOW_LOOKBACK_DAYS).toISOString();
	}

	const lookupPeriod =
		parkingLocation.violationCheckType === 'fixedMonthly'
			? -1
			: parkingLocation.violationCheckWindowDays || 0;

	return getLookupStartDate(lookupPeriod);
}
